<div class="card" *ngIf="!isMockUp; else mockupCard">
  <div [ngClass]="card.DatePictoColor" class="card__side_ribbon"></div>

  <div class="card__body">
    <div class="card__title q-c-main q-bold card__title--2line" title="{{card.Title}} - {{card.Code}}">{{card.Title}} - <span class="q-c-light-black">{{card.Code}}</span></div>
    <div class="card__text  mt-2 card__text--lean">
      {{card.Description}}
    </div>
  </div>
  <div class="card__footer">
    <div class="footer__price">
      <div class="card__date"><i class="fa-regular fa-clock"></i> {{card.StrDateMaj}}</div>
    </div>
    <div class="footer__picto">     
      <div class="card__action q-c-main" title="Nombre d'action"> {{card.NbAction}}</div>
    </div>
  </div>
</div>





<ng-template #mockupCard>
  <div class="card mockup">
    <div class="card__body">
      <div class="card__title q-c-main q-bold row mx-0 card__title--2line ">
        <div class="placeholder col-3"></div>
      </div>      
      <div class="card__text mb-1 pipeCard-desc row mx-0">
        <div class="placeholder col-1"></div>
        <div class="placeholder col-1"></div>
        <div class="placeholder col-4"></div>
        <div class="placeholder col-2"></div>
        <div class="placeholder col-1"></div>
        <div class="placeholder col-1"></div>
        <div class="placeholder col-4"></div>
        <div class="placeholder col-2"></div>
      </div>
    </div>
    <div class="card__footer">
      <div class="footer__price">
       
        <div class="placeholder col-3"></div>
      </div>
      <div class="footer__picto">
       
        <div class="placeholder col-1"></div>
      </div>
    </div>
  </div>
</ng-template>






